// 注册组件
import Vue from 'vue';

import {
    Card,
    CcLoading,
} from '@/commons/components/cc';

Vue.component('CcCard', Card);
Vue.component('CcLoading', CcLoading);
